/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/right-panel/__generated__/rightPanelAsyncQuery.graphql.ts
 */

export const RIGHT_PANEL_ASYNC_QUERY_PERSISTED_ID = '544db1c2c21fb97d410a3ea7a4f85a8695606636eb356dba2c43c66119e3b686';
export const RIGHT_PANEL_ASYNC_QUERY_OPERATION_NAME = 'rightPanelAsyncQuery';
